(function (jq, dell) {
    dell.Components = dell.Components || {};
    dell.Components.RecentlyPurchasedProducts = dell.Components.RecentlyPurchasedProducts || {};
    (function () {

        this.createRppsHtml = (response) => {
            let purchasedProd = response.Result;
            let purchasedProdList = purchasedProd.Assets;
            let cmsContent = purchasedProd.ServiceTagLabel;
            let i = 0, j;
            var html = '';
            for (i = 0, j = purchasedProdList.length; i < j; i++) {
                html = html + `<div class="slide"><div><div class="js-additional-product mb-10"><span class="badge badge-pill badge-purple mb-2">${purchasedProd.Title}</span><div class="d-flex"><div class="product-image mr-2">
                                <a href="${purchasedProdList[i].TargetUrl}" onclick="Dell.Components.RecentlyPurchasedProducts.purchasedproductsCallBack('${purchasedProdList[i].EsvcTag}','${purchasedProdList[i].EPsvcTag}');"><img src="${purchasedProdList[i].ImageUrl}" title="${purchasedProdList[i].ProductName}" /></a>
                            </div>
                            <div><a href="${purchasedProdList[i].TargetUrl}" onclick="Dell.Components.RecentlyPurchasedProducts.purchasedproductsCallBack('${purchasedProdList[i].EsvcTag}','${purchasedProdList[i].EPsvcTag}');">${purchasedProdList[i].ProductName}</a><p class="text-graphite mb-0">${cmsContent} ${purchasedProdList[i].EsvcTag}</p></div>
                        </div></div></div></div>`;
            }

            return html;
            // Empty slide used to allow last slide to be in full view
            //this.renderView(`<div class="slide"><div class="d-none js-additional-product"></div></div>`);
        };

        this.renderView = (html) => {
            $('#supportAssistWidget').slick('slickAdd', html);
        };

        var createRppsHtmlString = this.createRppsHtml;
        var renderView1 = this.renderView;
        this.getPurchasedProducts = () => {
            let urlPath = this.Url();
            let url = `${urlPath.baseUrl}/${urlPath.getPurchasedproducts}`;
            this.makeAjaxCall(url, "GET")
                .done(function (response) {
                    let html = createRppsHtmlString(response);
                    renderView1(html);
                }).fail(function () {
                    console.log('Purchased Product api failed');
                });
        };

        this.Url = () => {
            if (Dell.OnlineUtils !== 'undefined' && Dell.OnlineUtils.Lwp !== 'undefined') {
                let baseUrl = 'https://www.dell.com/support/components';
                if (Dell.ComponentLoader.baseUrls !== undefined && Dell.ComponentLoader.baseUrls["rpps"]) {
                    baseUrl = Dell.ComponentLoader.baseUrls["rpps"];
                }
                let urls = {
                    baseUrl: baseUrl,
                    getPurchasedproducts: 'purchasedproducts/products?appName=' + Dell.ComponentLoader.appNames["rpps"]
                };
                return urls;
            }
            return '';
        };

        this.purchasedproductsCallBack = (serviceTag, encServiceTag) => {
            if (eval("typeof window.PurchasedproductsCallBack") !== "undefined") {
                let callBackFun = eval("window.PurchasedproductsCallBack");
                let data = {
                    "serviceTag": serviceTag,
                    "encryptedServiceTag": encServiceTag
                };
                let returnObj = callBackFun.call(this, data);
                if (returnObj !== undefined && returnObj === false) {
                    event.preventDefault();
                }
            }
        };

        this.makeAjaxCall = (url, methodType) => {
            if (Dell.ComponentLoader.isAuth) {
                let ajaxData = {
                    url: url,
                    method: methodType,
                    dataType: "json",
                    cache: false,
                    contentType: "application/json;",
                    async: true
                };

                if (url.indexOf("//.dell.com") === -1) {
                    ajaxData.xhrFields = {
                        withCredentials: true
                    };
                }
                return jq.ajax(ajaxData);
            } else {
                let dfd = $.Deferred();
                dfd.resolve();
                return dfd.promise();
            }
        };

    }).apply(dell.Components.RecentlyPurchasedProducts);
})(jQuery, Dell = window.Dell || {});